<div class="flex items-center mr-2 lg:mr-8">
    <a (click)="ckeckModifica()" [href]="authLink('https://www.comune.laspezia.it')" target="_blank">
        <img class="dark:hidden  md:w-20 sm:w-15 h-auto rounded-full" src="assets/images/spezia/logo.png"
            alt="Logo Citta della spezia">
    </a>

    <div class="text-white font-semibold text-3xl ml-5 md:hidden">Città della Spezia</div>


    <a class="ml-4" (click)="ckeckModifica()" [href]="authLink('https://www.comune.laspezia.it')" target="_blank">
        <div class="flex flex-col md:w-full md:h-full sm:h-20">
            <div class="text-white font-semibold md:text-4xl sm:hidden md:flex">Città della Spezia</div>
            <div class="text-white text-base sm:hidden md:flex">Medaglia d'oro al Merito Civile</div>
            <div class="text-white text-base sm:hidden md:flex">Medaglia d'argento al Valor Militare</div>
        </div>
    </a>
</div>
